import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import {Helmet} from "react-helmet";
import PostIcons from "../components/PostIcons";

const Category = ({ data }) => (
    <div>
        <Helmet encodeSpecialCharacters={false}>
            <meta charSet="utf-8" />
            <meta name="description" content={`All blog posts under category ${data.contentfulCategory.name}`} />
            <title>{`${data.contentfulSiteSettings.title} - ${data.contentfulCategory.name}`}</title>
        </Helmet>
        <header className="page-header">
            <div className="page-header-wrapper">
                <h1 className="page-title">Category: {data.contentfulCategory.name}</h1>
            </div>
        </header>
        
        <section className="row posts-loop ">
            {data.allContentfulBlogPost && data.allContentfulBlogPost.edges.map(({ node }) => (
            <div className="post-wrapper col-12" key={node.slug}>
                <article className="list-post post type-post status-publish format-standard hentry">    
                    <div className="entry-header">
                        <PostIcons node={node} className="entry-meta" />
                        <h2 className="entry-title">
                            <Link to={`/${node.slug}`} dangerouslySetInnerHTML={{ __html: node.title }} />
                        </h2>
                    </div>

                    <div className="entry-summary">
                        <span dangerouslySetInnerHTML={{ __html: node.body.childMarkdownRemark.excerpt + ' [...] ' }}></span>
                        <span className="read-more-link"><Link to={`/${node.slug}`} className="read-more">Read More</Link></span>
                    </div>
                </article>
            </div>
            ))}
        </section>
    </div>
);

export default Category;

export const pageQuery = graphql`
  query currentPostsByCategoryQuery($id: String!) {
    contentfulCategory(id: {eq: $id}) {
        name
    }
    allContentfulBlogPost(filter: {categories: {id: {eq: $id}}}) {
        edges {
          node {
            id
            slug
            title
            body {
                childMarkdownRemark {
                    html
                    excerpt,
                }
            }
            date: publishDate(formatString: "MMMM DD, YYYY")
            shortDate: publishDate(formatString: "YYYY/MM/DD")
            categories {
              name
              slug
            }
          }
        }
    }
    contentfulSiteSettings {
        title
      }
  }
`



// WEBPACK FOOTER //
// ./src/templates/category.js